export default {"src":"/_next/static/media/logo-white.7965ad70.svg","height":34,"width":171,"blurWidth":0,"blurHeight":0};